import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AppBar from "@material-ui/core/AppBar";
// import {
//   AzureAD,
//   logout,
// } from "react-aad-msal";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import MenuIcon from "@material-ui/icons/Menu";
import Hidden from "@material-ui/core/Hidden";
import logo from "../assets/logo.svg";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Badge from "@material-ui/core/Badge";
import { Toolbar } from "@material-ui/core";
import HeaderStyles from "../themes/HeaderStyles";
// import makeStyles from "../themes/makeStyles";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      mobileMoreAnchorEl: null,
      open: null
    };
  }
  handleProfileMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget, open: true });
  };
  handleMenuClose = () => {
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };
  handleMobileMenuOpen = (event) => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };
  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };
  render() {
    const { handleChangeNavDrawer, classes, navDrawerOpen, logout } = this.props;
    const { anchorEl, open } = this.state;
    const isMenuOpen = Boolean(anchorEl);
    return (
      <div>
        <Hidden mdUp>
          <AppBar
            color="white"
            className={classNames(classes.appbar, classes.elevationNone)}
          >
            <Avatar alt="Tmill logo" src={logo} className={classes.small} />
          </AppBar>
        </Hidden>
        <AppBar
          className={classNames(
            classes.appBar,
            {
              [classes.appBarShift]: !navDrawerOpen,
            },
            classes.elevationNone
          )}
        >
          <Toolbar className="elevationNone">
            <IconButton
              className={classes.menuButton}
              color="inherit"
              aria-label="Open drawer"
              //onMouseEnter={handleChangeNavDrawer}
              //onMouseLeave={handleChangeNavDrawer}
              onClick={handleChangeNavDrawer}
            >
              <MenuIcon />
            </IconButton>
            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              <IconButton color="inherit">
                <Badge
                  className={classes.margin}
                  //badgeContent={""}
                  color="secondary"
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <IconButton
                aria-owns={isMenuOpen ? "material-appbar" : null}
                aria-haspopup="true"
                onClick={this.handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton color="inherit">
                <Badge
                  className={classes.margin}
                  badgeContent={17}
                  color="secondary"
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <IconButton
                aria-owns={isMenuOpen ? "material-appbar" : null}
                aria-haspopup="true"
                onClick={this.handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={logout}
              >
                <MenuItem onClick={logout}>Log out</MenuItem>
                {/* <MenuItem onClick={this.handleClose}>My account</MenuItem> */}
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}
Header.propTypes = {
  styles: PropTypes.object,
  handleChangeNavDrawer: PropTypes.func,
  classes: PropTypes.object,
  navDrawerOpen: PropTypes.bool,
  handleClose: PropTypes.func,
};
export default withStyles(HeaderStyles)(Header);
